import { ReactComponent as ArrowDown } from '../../assets/icons/arrow-down.svg';
import { ReactComponent as ArrowUp } from '../../assets/icons/arrow-up.svg';
import { ReactComponent as ArrowLeft } from '../../assets/icons/arrow-left.svg';
import { ReactComponent as ArrowLeft2 } from '../../assets/icons/arrow-left2.svg';
import { ReactComponent as ArrowRight } from '../../assets/icons/arrow-right.svg';
import { ReactComponent as Close } from '../../assets/icons/close.svg';
import { ReactComponent as CloseRounded } from '../../assets/icons/close-rounded.svg';
import { ReactComponent as AccountData } from '../../assets/icons/accountData.svg';
import { ReactComponent as Delete } from '../../assets/icons/delete.svg';
import { ReactComponent as Device } from '../../assets/icons/device.svg';
import { ReactComponent as Download } from '../../assets/icons/download.svg';
import { ReactComponent as EditPencil } from '../../assets/icons/edit-pencil.svg';
import { ReactComponent as EmailApprove } from '../../assets/icons/email-approve.svg';
import { ReactComponent as EmailError } from '../../assets/icons/email-error.svg';
import { ReactComponent as Error } from '../../assets/icons/error.svg';
import { ReactComponent as ErrorOutlined } from '../../assets/icons/error-outlined.svg';
import { ReactComponent as Eye } from '../../assets/icons/eye.svg';
import { ReactComponent as EyeClose } from '../../assets/icons/eye-close.svg';
import { ReactComponent as FaceSad } from '../../assets/icons/face-sad.svg';
import { ReactComponent as FlagBrasil } from '../../assets/icons/flag-brasil.svg';
import { ReactComponent as Plus } from '../../assets/icons/plus.svg';
import { ReactComponent as Interrogation } from '../../assets/icons/interrogation.svg';
import { ReactComponent as Info } from '../../assets/icons/info.svg';
import { ReactComponent as InfoOutlined } from '../../assets/icons/info-outlined.svg';
import { ReactComponent as Lock } from '../../assets/icons/lock.svg';
import { ReactComponent as Loading } from '../../assets/icons/loading.svg';
import { ReactComponent as LogoApple } from '../../assets/icons/logo-apple.svg';
import { ReactComponent as LogoFace } from '../../assets/icons/logo-facebook.svg';
import { ReactComponent as LogoGoogle } from '../../assets/icons/logo-google.svg';
import { ReactComponent as LogoMicrosoft } from '../../assets/icons/logo-microsoft.svg';
import { ReactComponent as LogoSbt } from '../../assets/icons/logo-sbt.svg';
import { ReactComponent as Sbt } from '../../assets/icons/sbt.svg';
import { ReactComponent as NewTab } from '../../assets/icons/new-tab.svg';
import { ReactComponent as Setup } from '../../assets/icons/setup.svg';
import { ReactComponent as Success } from '../../assets/icons/success.svg';
import { ReactComponent as SuccessOutlined } from '../../assets/icons/success-outlined.svg';
import { ReactComponent as Trash } from '../../assets/icons/trash.svg';
import { ReactComponent as TriangleExclamation } from '../../assets/icons/triangle-exclamation.svg';
import { ReactComponent as CheckedSuccessfully } from '../../assets/icons/checked-successfully.svg';
import { ReactComponent as Vector } from '../../assets/icons/vector.svg';
import { ReactComponent as Chrome } from '../../assets/icons/chrome.svg';
import { ReactComponent as Edge } from '../../assets/icons/edge.svg';
import { ReactComponent as Firefox } from '../../assets/icons/Firefox.svg';
import { ReactComponent as Unknown } from '../../assets/icons/unknown.svg';
import { ReactComponent as Caution } from '../../assets/icons/caution.svg';
import { ReactComponent as Opera } from '../../assets/icons/opera.svg';
import { ReactComponent as Safari } from '../../assets/icons/safari.svg';
import { ReactComponent as Loader } from '../../assets/icons/loader.svg';
import { ReactComponent as Help } from '../../assets/icons/help.svg';
import { ReactComponent as ShieldVerified } from '../../assets/icons/shield-verified.svg';
import { ReactComponent as Mic } from '../../assets/icons/mic.svg';
import { ReactComponent as Like } from '../../assets/icons/like.svg';
import { ReactComponent as Link } from '../../assets/icons/link.svg';
import { ReactComponent as Search } from '../../assets/icons/search.svg';

import { ReactComponent as Exclamation } from '../../assets/icons/exclamation.svg';

import { ReactComponent as Email } from '../../assets/icons/email.svg';
import { ReactComponent as Password } from '../../assets/icons/password.svg';
import { ReactComponent as Birthdate } from '../../assets/icons/birthdate.svg';
import { ReactComponent as PersonId } from '../../assets/icons/personId.svg';
import { ReactComponent as Mobile } from '../../assets/icons/mobile.svg';
import { ReactComponent as Address } from '../../assets/icons/address.svg';
import { ReactComponent as Cookies } from '../../assets/icons/cookies.svg';

import { ReactComponent as MaisSBT } from '../../assets/icons/maissbt.svg';
import { ReactComponent as SBTTV } from '../../assets/icons/sbttv.svg';
import { ReactComponent as SBTSports } from '../../assets/icons/sbtsports.svg';
import { ReactComponent as SBTNews } from '../../assets/icons/sbtnews.svg';

import { ReactComponent as Dash } from '../../assets/icons/dash.svg';
import { ReactComponent as Person } from '../../assets/icons/person.svg';
import { ReactComponent as Chat } from '../../assets/icons/chat.svg';
import { ReactComponent as Shield } from '../../assets/icons/shield.svg';
import { ReactComponent as Setting } from '../../assets/icons/setting.svg';

import { ReactComponent as Age6 } from '../../assets/icons/age-6.svg';
import { ReactComponent as AgeA6 } from '../../assets/icons/age-a6.svg';
import { ReactComponent as Age10 } from '../../assets/icons/age-10.svg';
import { ReactComponent as AgeA10 } from '../../assets/icons/age-a10.svg';
import { ReactComponent as Age12 } from '../../assets/icons/age-12.svg';
import { ReactComponent as AgeA12 } from '../../assets/icons/age-a12.svg';
import { ReactComponent as Age14 } from '../../assets/icons/age-14.svg';
import { ReactComponent as AgeA14 } from '../../assets/icons/age-a14.svg';
import { ReactComponent as Age16 } from '../../assets/icons/age-16.svg';
import { ReactComponent as AgeA16 } from '../../assets/icons/age-a16.svg';
import { ReactComponent as Age18 } from '../../assets/icons/age-18.svg';
import { ReactComponent as AgeA18 } from '../../assets/icons/age-a18.svg';
import { ReactComponent as AgeL } from '../../assets/icons/age-l.svg';
import { ReactComponent as AgeAL } from '../../assets/icons/age-al.svg';

type IconProps = { name: string };
type IconTypes = { [name: string]: React.FunctionComponent };

const iconTypes: IconTypes = {
  arrowDown: ArrowDown,
  arrowUp: ArrowUp,
  arrowLeft: ArrowLeft,
  arrowLeft2: ArrowLeft2,
  arrowRight: ArrowRight,
  close: Close,
  closeRounded: CloseRounded,
  accountData: AccountData,
  delete: Delete,
  device: Device,
  download: Download,
  editPencil: EditPencil,
  emailApprove: EmailApprove,
  emailError: EmailError,
  error: Error,
  errorOutlined: ErrorOutlined,
  eye: Eye,
  eyeClose: EyeClose,
  faceSad: FaceSad,
  flagBrasil: FlagBrasil,
  iconPlus: Plus,
  interrogation: Interrogation,
  info: Info,
  infoOutlined: InfoOutlined,
  lock: Lock,
  loading: Loading,
  logoApple: LogoApple,
  logoFace: LogoFace,
  logoGoogle: LogoGoogle,
  logoMicrosoft: LogoMicrosoft,
  logoSbt: LogoSbt,
  newTab: NewTab,
  plus: Plus,
  setup: Setup,
  cookies: Cookies,
  search: Search,
  success: Success,
  help: Help,
  shieldVerified: ShieldVerified,
  mic: Mic,
  like: Like,
  link: Link,
  successOutlined: SuccessOutlined,
  trash: Trash,
  trashButton: Trash,
  triangleExclamation: TriangleExclamation,
  checkedSuccessfully: CheckedSuccessfully,
  vector: Vector,
  chrome: Chrome,
  edge: Edge,
  firefox: Firefox,
  unknown: Unknown,
  caution: Caution,
  opera: Opera,
  safari: Safari,

  exclamation: Exclamation,

  email: Email,
  password: Password,
  birthdate: Birthdate,
  personId: PersonId,
  mobile: Mobile,
  address: Address,

  loader: Loader,

  age6: Age6,
  ageA6: AgeA6,
  age10: Age10,
  ageA10: AgeA10,
  age12: Age12,
  ageA12: AgeA12,
  age14: Age14,
  ageA14: AgeA14,
  age16: Age16,
  ageA16: AgeA16,
  age18: Age18,
  ageA18: AgeA18,
  ageL: AgeL,
  ageAL: AgeAL,

  dash: Dash,
  person: Person,
  chat: Chat,
  shield: Shield,
  setting: Setting,

  sbt: Sbt,
  sbtsports: SBTSports,
  sbtnews: SBTNews,
  maissbt: MaisSBT,
  sbttv: SBTTV
};

const Icon = ({ name, ...props }: IconProps | any) => {
  const Icon = iconTypes[name];
  return <Icon {...props} fill="red" />;
};

export default Icon;
